import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter,
  ModalButtons,
  Button,
  Alert,
} from 'pvs-design-system';
import { Stack } from '@mui/material';

interface ErrorModalProps {
  title: string;
  errorMessage: string;
  infoMessage: string;
  isOpen: boolean;
  onClose: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  title,
  errorMessage,
  infoMessage,
  isOpen,
  onClose,
}) => {
  return (
    <Modal onClose={onClose} open={isOpen} closeModalOnBackdropClick>
      <ModalHeader title={title} onClose={onClose} description="" />
      <ModalContent>
        <Stack gap="16px">
          <Alert severity="error">{errorMessage}</Alert>
          {infoMessage}
        </Stack>
      </ModalContent>
      <ModalFooter>
        <ModalButtons>
          <Button id="modalClose" onClick={onClose}>
            Close
          </Button>
        </ModalButtons>
      </ModalFooter>
    </Modal>
  );
};

export default ErrorModal;
